import request from "./request";
import apis from "./apis";

const {
  rollCallGroup,
  rollCallInfo,
  updateRollCall,
  vacationAndMakeUpDay,
} = apis.rollCall;

const rollCall = {
  getRollCallGroupInfo: () => {
    return request.get(rollCallGroup);
  },
  getRollCallInfo: (data: Object) => {
    return request.get(rollCallInfo, data);
  },
  updateRollCall: (data: Object) => {
    return request.put(updateRollCall, data);
  },
  getVacationAndMakeUpDay: (data: Object) => {
    return request.get(vacationAndMakeUpDay, data);
  },
};

export default rollCall;